import {
  assignSettinOptimizedAddToCartDebounce,
  getSettingOptimizedAddToCartDebounce,
} from "@faire/retailer-visitor-shared/settings/getSettingOptimizedAddToCartDebounce";
import {
  ICartItemForUpdate,
  UpdateCartHandler,
} from "@faire/retailer-visitor-shared/stores/domain/CartStore/consts";
import { AddToCartVariants } from "@faire/retailer-visitor-shared/stores/domain/CartStore/triggerAddToCartEvent";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { action, observable } from "mobx";

export const BULK_UPDATE_DEBOUNCE_THREHOLD = 3000;
const OPTIMIZED_BULK_UPDATE_DEBOUNCE_THREHOLD = 500;
/**
 * @deprecated use `useBulkUpdateCartItem` instead in functional components
 */
export class BulkUpdateItemClass {
  constructor(
    private updateCart: UpdateCartHandler | undefined,
    container: string
  ) {
    this.container = container;
  }

  private container: string = "";

  @observable
  private bulkUpdates: Record<string, ICartItemForUpdate> = {};

  @observable
  private itemType: Record<string, boolean> = {};

  private track = (token: string, isMultiOption: boolean) => {
    const container = this.container;

    const cartAddType = isMultiOption
      ? "quick_add_with_options_chosen"
      : "quick_add";

    trackEvent(`/container/${container}/${cartAddType}/${token}`);
  };

  @action
  bulkUpdateItems = (
    productToken: string,
    productOptionToken: string,
    value: number,
    isMultiOption: boolean,
    brandToken: string,
    variant: AddToCartVariants,
    onSubmit?: () => void
  ) => {
    const key = productToken + productOptionToken;
    const currentTime = performance.now();
    this.bulkUpdates[key] = ICartItemForUpdate.build({
      product_token: productToken,
      product_option_token: productOptionToken,
      quantity: value < 0 ? 0 : value,
      brand_token: brandToken,
    });
    this.itemType[key] = isMultiOption;
    if (Object.values(this.bulkUpdates).length) {
      this.debouncedUpdateCart(variant, currentTime, onSubmit);
    }
  };

  private debouncedUpdateCart = debounceIfPossible(
    async (
      variant: AddToCartVariants,
      timeOfLastAddToCartClick: number,
      onSubmit?: () => void
    ) => {
      if (this.updateCart) {
        assignSettinOptimizedAddToCartDebounce();
        Object.values(this.bulkUpdates).forEach((value) => {
          const key =
            (value.product_token ?? "") + (value.product_option_token ?? "");
          this.track(
            value.product_option_token ?? "",
            this.itemType[key] || false
          );
        });
        if (getSettingOptimizedAddToCartDebounce()) {
          const updatedCartItems = Object.values(this.bulkUpdates);
          this.bulkUpdates = {};
          await this.updateCart(updatedCartItems, {
            upltParams: {
              event: "add-to-cart",
              startTime: timeOfLastAddToCartClick,
              variant,
            },
          });
        } else {
          await this.updateCart(Object.values(this.bulkUpdates), {
            upltParams: {
              event: "add-to-cart",
              startTime: timeOfLastAddToCartClick,
              variant,
            },
          });
          this.bulkUpdates = {};
        }
        onSubmit?.();
      }
    },
    getSettingOptimizedAddToCartDebounce()
      ? OPTIMIZED_BULK_UPDATE_DEBOUNCE_THREHOLD
      : BULK_UPDATE_DEBOUNCE_THREHOLD
  );
}
